import { useTranslation } from '../../hooks/useTranslation';
import { parseText } from '../../utils/string/parseText';

export const TermsAndConditionsPage = () => {
  const { data } = useTranslation();

  return (
    <div className="mx-auto w-11/12 md:w-9/12">
      <h1 className="text-h2 mb-space-500">{data?.termsAndConditions?.title}</h1>

      {data?.termsAndConditions?.content.map((content, index) => (
        <section key={index} className="mb-space-600">
          {content.heading && <h2 className="text-h5 mb-space-300">{content.heading}</h2>}

          {content.paragraphs?.map((paragraph, paragraphIndex) => (
            <p key={paragraphIndex} className="mb-space-300">
              {parseText(paragraph, content.links ?? [])}
            </p>
          ))}
        </section>
      ))}
    </div>
  );
};
